const STATUS_LABEL_CLASS = {
    in_attesa: 'label-default',
    in_corso: 'label-warning',
    completato: 'label-success',
};

function csrfToken() {
    return $('meta[name="csrf-token"]').attr('content');
}

function escapeHtml(value) {
    return $('<div>').text(value == null ? '' : String(value)).html();
}

function routeWithId(template, id) {
    return String(template).replace('__ID__', id);
}

function todayIso() {
    const d = new Date();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + day;
}

const WorkingBlocksPlanning = {
    config: null,
    containerId: null,
    statuses: [],
    blocks: {},
    initialized: false,

    init(containerId) {
        const config = window.__workingBlocksPlanningConfig;
        if (!config || this.initialized) {
            return;
        }
        const container = document.getElementById(containerId);
        if (!container) {
            return;
        }
        this.initialized = true;
        this.config = config;
        this.containerId = containerId;
        this.bindEvents(container);
        this.load();
    },

    bindEvents(container) {
        const self = this;
        $(container).on('change', '.wb-plan-status-select', function () {
            const sheetId = parseInt($(this).data('sheet-id'), 10);
            self.changeStatus(sheetId, $(this).val(), this);
        });
    },

    load() {
        const self = this;
        const $container = $('#' + this.containerId);
        $.ajax({
            url: this.config.dataUrl,
            method: 'GET',
            success(response) {
                if (!response || !response.success) {
                    $container.html('<div class="text-danger">Errore nel caricamento dei dati.</div>');
                    return;
                }
                self.statuses = response.statuses || [];
                self.render(response.columns || []);
            },
            error() {
                $container.html('<div class="text-danger">Errore nel caricamento dei dati.</div>');
            },
        });
    },

    render(columns) {
        const self = this;
        this.blocks = {};

        if (!columns.length) {
            $('#' + this.containerId).html('<div class="text-muted">Nessun Working Block da pianificare.</div>');
            return;
        }

        const columnsHtml = columns.map((column) => {
            const cards = (column.blocks || []).map((block) => {
                self.blocks[block.id] = block;
                return self.buildCardHtml(block);
            }).join('');

            const body = cards || '<div class="wb-plan-empty text-muted">Nessun blocco</div>';

            return '' +
                '<div class="wb-plan-column">' +
                    '<div class="wb-plan-column-head">' +
                        '<span class="wb-plan-column-title">' + escapeHtml(column.name) + '</span>' +
                        '<span class="badge">' + (column.blocks ? column.blocks.length : 0) + '</span>' +
                    '</div>' +
                    '<div class="wb-plan-column-body">' + body + '</div>' +
                '</div>';
        }).join('');

        $('#' + this.containerId).html('<div class="wb-plan-columns">' + columnsHtml + '</div>');
    },

    refreshColumn($column) {
        if (!$column || !$column.length) {
            return;
        }
        const $body = $column.find('.wb-plan-column-body');
        const count = $body.find('.wb-plan-card').length;
        $column.find('.wb-plan-column-head .badge').text(count);
        if (count === 0 && !$body.find('.wb-plan-empty').length) {
            $body.html('<div class="wb-plan-empty text-muted">Nessun blocco</div>');
        }
    },

    buildCardHtml(block) {
        const isBlocked = block.is_blocked === true;
        const statusClass = STATUS_LABEL_CLASS[block.status] || 'label-default';
        const blockedClass = isBlocked ? ' wb-plan-card-blocked' : '';

        let statusControl = '<span class="label ' + statusClass + '">' + escapeHtml(block.status_label) + '</span>';
        if (block.can_modify) {
            if (isBlocked) {
                statusControl = '<select class="form-control input-sm wb-plan-status-select wb-plan-status-select-disabled" data-sheet-id="' + block.id + '" disabled>' +
                    '<option value="in_attesa" selected>In attesa</option>' +
                    '</select>';
            } else {
                const options = this.statuses.map((s) => {
                    const selected = s.value === block.status ? ' selected' : '';
                    return '<option value="' + escapeHtml(s.value) + '"' + selected + '>' + escapeHtml(s.label) + '</option>';
                }).join('');
                statusControl = '<select class="form-control input-sm wb-plan-status-select" data-sheet-id="' + block.id + '">' + options + '</select>';
            }
        }

        let datesHtml = '';
        const startPart = block.start_date_label
            ? '<span class="wb-plan-date"><i class="fa fa-play"></i> ' + escapeHtml(block.start_date_label) + '</span>'
            : '';
        let duePart = '';
        if (block.due_date_label) {
            const overdue = block.due_date && block.status !== 'completato' && block.due_date < todayIso();
            duePart = '<span class="wb-plan-date wb-plan-due' + (overdue ? ' wb-plan-overdue' : '') + '"><i class="fa fa-flag-checkered"></i> ' + escapeHtml(block.due_date_label) + '</span>';
        }
        if (startPart || duePart) {
            datesHtml = '<div class="wb-plan-dates">' + startPart + duePart + '</div>';
        }

        const projectLabel = escapeHtml(block.project_label);
        const projectHtml = block.project_url
            ? '<a class="wb-plan-project" href="' + escapeHtml(block.project_url) + '" title="' + projectLabel + '">' + projectLabel + '</a>'
            : '<span class="wb-plan-project">' + projectLabel + '</span>';

        const blockedHint = isBlocked
            ? '<div class="wb-plan-blocked-hint"><i class="fa fa-lock"></i> In attesa di: ' +
                escapeHtml((block.blocked_by || []).join(', ') || 'passaggi precedenti') +
            '</div>'
            : '';

        return '' +
            '<div class="wb-plan-card wb-status-' + escapeHtml(block.status) + blockedClass + '" data-sheet-id="' + block.id + '">' +
                projectHtml +
                '<div class="wb-plan-card-title">' + escapeHtml(block.name) + '</div>' +
                blockedHint +
                '<div class="wb-plan-card-meta">' +
                    '<span class="wb-plan-task-count"><i class="fa fa-tasks"></i> ' + (block.task_count || 0) + '</span>' +
                    datesHtml +
                '</div>' +
                '<div class="wb-plan-card-status">' + statusControl + '</div>' +
            '</div>';
    },

    changeStatus(sheetId, status, selectEl) {
        const self = this;
        const block = self.blocks[sheetId];
        if (block && block.is_blocked === true) {
            window.Swal && window.Swal.fire({
                icon: 'warning',
                title: 'Operazione non consentita',
                text: 'Completa prima: ' + ((block.blocked_by || []).join(', ') || 'i Working Block precedenti'),
            });
            if (selectEl) {
                $(selectEl).val('in_attesa');
            }
            return;
        }

        $.ajax({
            url: routeWithId(this.config.statusRoute, sheetId),
            method: 'PUT',
            data: { status: status, _token: csrfToken() },
            success(response) {
                if (response && response.success && response.block) {
                    if (response.block.status === 'completato') {
                        self.load();
                        return;
                    }

                    self.load();
                }
            },
            error(xhr) {
                const msg = xhr.responseJSON?.errors?.status
                    ? xhr.responseJSON.errors.status[0]
                    : (xhr.responseJSON?.message || 'Impossibile aggiornare lo stato.');
                window.Swal && window.Swal.fire({ icon: 'error', title: 'Operazione non consentita', text: msg });
                const block = self.blocks[sheetId];
                if (block && selectEl) {
                    $(selectEl).val(block.status);
                }
            },
        });
    },
};

module.exports = WorkingBlocksPlanning;
